import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import ProfileViewPage from './ProfileViewPage';

const ProfilePage = () => {

  const match = useRouteMatch();

  return (
    <Switch>
      <Route exact path={match.url}>
        <ProfileViewPage />
      </Route>
    </Switch>
  );
};

export default ProfilePage;
